<template>
    <FunnelStepContainer>
        <template #image>
            <img class="h-7 w-7 rounded-full ring-1" src="/img/home/funnel-man.png" alt="" />
        </template>
        <template #title>{{ step.title[form.orderer] }}</template>
        <template #description>{{ step.description }}</template>
        <div class="mx-auto mt-12 flex max-w-lg flex-col items-center justify-between gap-10 rounded-xl p-8 lg:p-4">
            <div class="w-full items-center gap-x-4 p-2">
                <label for="state" class="text-sm font-medium leading-6 text-gray-900"> Bundesland </label>
                <select
                    id="state"
                    name="state"
                    class="relative mt-2 w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-base text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6"
                    v-model="selectedValue"
                >
                    <option disabled value="">Bitte wählen</option>
                    <option v-for="state in step.options.states" :key="state.key" :value="state.key">
                        {{ state.label }}
                    </option>
                </select>
            </div>
        </div>
        <div class="mt-12 flex justify-center gap-4">
            <button
                @click="submitOption"
                class="rounded-xl bg-sky-50 px-3.5 py-2.5 text-base font-medium text-sky-900 shadow-sm ring-inset ring-sky-300 hover:bg-sky-50 hover:ring-2"
            >
                Weiter
            </button>
        </div>
    </FunnelStepContainer>
</template>

<script setup>
import { ref } from 'vue'
import FunnelStepContainer from '@/Components/Funnel/FunnelStepContainer.vue'
const emit = defineEmits(['step-submitted'])

const props = defineProps({
    step: {
        type: Object,
        required: true,
    },
    form: {
        type: Object,
        required: true,
    },
})

const selectedValue = ref('')

function submitOption() {
    props.form[props.step.formField] = selectedValue.value

    console.log(props.form)

    let nextStep = props.step.next(props.form)
    emit('step-submitted', nextStep)
}
</script>
